import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import Footer from '../../components/Footer.vue';
import { Cellphone, ChatDotRound } from '@element-plus/icons-vue';
import RemoteJs from '../components/RemoteJs/index.vue';
// import CaptCha from '../components/Captcha/index.vue'
import { ElMessage } from 'element-plus';
export default {
  components: {
    Footer,
    Cellphone,
    ChatDotRound,
    RemoteJs,
    // CaptCha,
    ElMessage
  },
  data() {
    let RegPhone = /^[1][34578][0-9]{9}$/;
    let RegResetPass = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
    // let RegResetPass = /^(?![0-9]+$)(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
    const validPhoneNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入您的手机号'));
      } else if (!RegPhone.test(value)) {
        callback(new Error('手机号码格式不正确'));
      } else {
        callback();
      }
    };
    const validResetPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else if (!RegResetPass.test(value)) {
        callback(new Error('请输入至少6位密码，需包含数字和字母'));
      } else {
        callback();
      }
    };
    return {
      locale: zhCn,
      projectInfo: null,
      url: this.$utils.getService() || '',
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          message: '请输入登录账号'
        }],
        password: [{
          required: true,
          trigger: 'blur',
          message: '请输入登录密码'
        }]
      },
      loading: false,
      checked: false,
      showResetDialog: false,
      passwordType: 'password',
      resetForm: {
        phoneNumber: '',
        code: '',
        password: ''
      },
      resetRules: {
        phoneNumber: [{
          required: true,
          trigger: 'blur',
          validator: validPhoneNumber
        }],
        code: [{
          required: true,
          trigger: 'blur',
          message: '请输入验证码'
        }, {
          min: 4,
          max: 4,
          message: '请输入四位验证码',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validResetPass
        }]
      },
      timer: null,
      count: '',
      codeShow: true,
      randstr: '',
      ticket: '',
      codeSuccess: false,
      logInType: 2,
      // 1:账号登录  2:工号登录
      returnTips: '<返回工号登录',
      schoolName: '天津中医药'
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      window.captchaCb = res => {
        console.log(res);
        this.randstr = res.randstr;
        this.ticket = res.ticket;
        // res（用户主动关闭验证码）= {ret: 2, ticket: null}
        // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
        if (res.ret === 0) {
          this.sendCode();
        }
        return Promise.reject();
      };
    });
  },
  unmounted() {
    window.__CaptchaExists__ = 0;
  },
  methods: {
    /* 判断是否跳转service 还是 首页 */
    async checkJumpService() {
      const service = this.$utils.getUrlParams('service');
      console.log('service :>> ', service);
      if (service) {
        window.open(decodeURIComponent(service), '_self');
      } else {
        window.location.href = '/index.html';
      }
    },
    handleLogin() {
      this.$refs['loginForm'].validate(valid => {
        if (valid) {
          this.loading = true;
          let {
            username,
            password
          } = this.loginForm;
          let params = {
            username,
            password,
            logInType: this.logInType
          };
          this.$http.getLogin(params).then(res => {
            if (res.token) this.$utils.setCookie('X-Access-Token', res.token);
            this.checkJumpService();
          }).catch(err => {
            //   ElMessage({
            //     type: 'error',
            //     message: err.message
            //   })
            this.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    forgetPassword() {
      this.showResetDialog = true;
    },
    async confirmReset() {
      console.log(this.$refs);
      this.$refs['resetForm'].validate(async valid => {
        if (valid) {
          let params = {
            code: this.resetForm.code,
            mobile: this.resetForm.phoneNumber,
            newPassword: this.resetForm.password,
            username: this.resetForm.phoneNumber
          };
          const res = await this.$http.validateCode(params);
          if (res) {
            let params = {
              code: this.resetForm.code,
              mobile: this.resetForm.phoneNumber,
              newPassword: this.resetForm.password
            };
            const res = await this.$http.resetPass(params);
            if (res) {
              this.showResetDialog = false;
              ElMessage({
                message: '修改成功，请使用新密码登录',
                type: 'success'
              });
            } else {
              ElMessage({
                message: '修改失败',
                type: 'warning'
              });
            }
            // window.location.href = `${this.$baseUrl}/login.html`
          } else {
            ElMessage({
              message: '验证码错误',
              type: 'warning'
            });
          }
        }
      });
    },
    getCode() {
      // debugger
      let Reg = /^[1][34578][0-9]{9}$/;
      if (!this.resetForm.phoneNumber) {
        ElMessage.warning({
          message: '请先输入您的手机号码',
          type: 'warning'
        });
        return;
      } else {
        if (Reg.test(this.resetForm.phoneNumber)) {
          let btn2 = document.getElementById('CaptchaEl');
          btn2.click();
        } else {
          ElMessage.warning({
            message: '手机号码格式不正确',
            type: 'warning'
          });
        }
      }
    },
    async codeMessage() {
      let params = {
        mobile: this.resetForm.phoneNumber,
        randStr: this.randstr,
        ticket: this.ticket,
        username: this.resetForm.phoneNumber,
        logInType: 1
      };
      const res = await this.$http.sendSmsCode(params);
      console.log(res);
      this.codeSuccess = res;
    },
    async sendCode() {
      console.log(this.randstr);
      this.codeMessage().then(() => {
        if (this.codeSuccess) {
          const timeCount = 60;
          if (!this.timer) {
            this.count = timeCount;
            this.codeShow = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= timeCount) {
                this.count--;
              } else {
                this.codeShow = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          ElMessage.warning({
            message: '请稍后再试',
            type: 'warning'
          });
        }
      }).catch(error => {
        ElMessage.warning({
          message: error.message,
          type: 'warning'
        });
      });
      console.log('123');
    },
    destroyForm() {
      this.resetForm = {
        phoneNumber: '',
        code: '',
        password: ''
      };
    }
  }
};